import React, {Component} from "react"
import styles from "./IconButton.module.css"
import {ReactComponent as IconSmile} from "./icons/smile.svg"
import {ReactComponent as IconShare} from "./icons/share.svg"
import {ReactComponent as IconRevert} from "./icons/revert.svg"
import {ReactComponent as IconDownload} from "./icons/download.svg"
import {ReactComponent as IconAttach} from "./icons/attach.svg"
import {ReactComponent as IconCam} from "./icons/cam.svg"
import {ReactComponent as IconTel} from "./icons/tel.svg"
import {ReactComponent as IconHeart} from "./icons/heart.svg"
import {ReactComponent as IconForward} from "./icons/forward.svg"

type Props = {
    disabled?: boolean
    onClick: () => void
    type: "smile" | "share" | "revert" | "download" | "attach" | "cam" | "tel" | "heart" | "forward"
}

export class IconButton extends Component<Props, {}> {
    private onClick(event) {
        const {onClick} = this.props
        event.preventDefault()
        onClick()
    }

    public render() {
        const {disabled, type} = this.props
        return (
            <button className={styles.root} onClick={this.onClick.bind(this)} disabled={disabled}>
                <Icon id={type} />
            </button>
        )
    }
}

function Icon({id}: {id: string}) {
    const props = {width: "17", height: "17", className: styles.icon}

    switch (id) {
        case "smile":
            return <IconSmile {...props} />
        case "share":
            return <IconShare {...props} />
        case "revert":
            return <IconRevert {...props} />
        case "download":
            return <IconDownload {...props} />
        case "attach":
            return <IconAttach {...props} />
        case "cam":
            return <IconCam {...props} />
        case "tel":
            return <IconTel {...props} />
        case "heart":
            return <IconHeart {...props} />
        case "forward":
            return <IconForward {...props} />

        default:
            return null
    }
}
